<template>
    <div class="muven-breadcrumb">
        <span v-for="(item, index) in items" :key="index"
            class="muven-breadcrumb-item">

            <span v-show="index !== 0">
                <fa icon="chevron-right" class="muven-breadcrumb-item-icon"></fa>
            </span>

            <router-link :to="item.path" 
                v-if="!!item.path">
                <ChannelLogoCmp v-if="item.channel" :channel="item.channel" :size="14" :show-name="false"
                    class="muven-breadcrumb-item-channel" />{{item.description}}</router-link>

            <span v-if="!item.path">
                <ChannelLogoCmp v-if="item.channel" :channel="item.channel" :size="14" :show-name="false"
                    class="muven-breadcrumb-item-channel" />{{item.description}}</span>
        </span>
    </div>
</template>

<script>
import ChannelLogoCmp from '@/channel/components/ChannelLogoCmp.vue'

export default {
    name: 'BreadcrumbCmp',
    components: {
        ChannelLogoCmp,
    },
    props: {
        items: {
            type: Array,
            default: [],
        },
    },
}
</script>

<style lang="scss" scoped>
.muven-breadcrumb {
    margin-top: -20px;

    .muven-breadcrumb-item {
        font-size: .8em;
        letter-spacing: 1px;

        a,span {
            color: var(--text);
            text-decoration: none;
        }

        a:hover {
            border-bottom: 1px solid var(--border-strong);
        }

        // Identidade do canal nas telas internas dele: pequeno, só um marcador
        // ao lado do nome, sem competir com o título da página.
        .muven-breadcrumb-item-channel {
            margin-right: 6px;
            vertical-align: -2px;
        }

        .muven-breadcrumb-item-icon {
            margin: 0 10px;
            font-size: .7em;
            color: var(--text-muted);
        }
    }
}
</style>
